var environment = {
    //BASE_URL: 'http://52.7.137.12:3002/api/web',
    BASE_URL2: 'http://localhost/api/v1',
    BASE_URL: 'https://gpiautocomercial.com:3000/api/web',
    COPOMEX: 'https://api.copomex.com/query',  
    WTS_URL: 'https://gpiautocomercial.com:3011/api',	
    //TOKENCOPOMEX: 'pruebas',
    TOKENCOPOMEX: '399cb6f9-5c9f-45e3-b0c9-a9c2d92334bd',
    TASA: 2.32,
    GPS: 199,
    SEGURODEUDOR: 95,
    GPS_SIN_IVA: 171.55,
    SEGURODEUDOR_SIN_IVA: 81.95,
    CAT_ANUAL: 56.4,
    MORATORIO: 8.0,
    COMISION_LOTE: 2,
    COMISION_LOTE_ALO: 3,
    COMISION_APERTURA: 3,
    COMISION_ASESOR: 2,
    MORATORIO_EMPLEADO: 3.7,
    IVA: 0.16
};
// process.env = environment;

export default environment;


// WEBPACK FOOTER //
// ./src/environments/Environment.js